import { AppDispatch } from '~/store';
import { logError } from '~/utils/logError';
import { Uploader } from '../lib/Uploader';
import {
  resetUploads,
  thumbnailGenerated,
  uploadAdded,
  uploadCompleted,
  uploadFailed,
  uploadProgress,
  uploadRemoved,
  uploadToS3Succeeded,
} from './slice';
import { uploadsLogger } from '../loggers';

export const boundUploaders = new WeakSet<Uploader>();

export function bindUploaderToReduxSlice(
  uploader: Uploader,
  { dispatch }: { dispatch: AppDispatch }
) {
  // We only want to bind events once per uploader
  if (boundUploaders.has(uploader)) return;
  uploadsLogger('Binding uploader to redux slice: %s', uploader.getId());

  boundUploaders.add(uploader);

  uploader.on('upload-started', (upload) => {
    dispatch(uploadAdded(upload));
  });

  uploader.on('thumbnail-generated', ({ id, thumbnailUrl }) => {
    dispatch(thumbnailGenerated({ id, thumbnailUrl }));
  });

  uploader.on('upload-failed', ({ id }, error) => {
    dispatch(uploadFailed({ id, error: error.message }));
  });

  uploader.on('upload-removed', (upload) => {
    dispatch(uploadRemoved(upload));
  });

  uploader.on('upload-to-s3-finished', ({ id, url, key, bucket }) => {
    dispatch(uploadToS3Succeeded({ id, url, key, bucket }));
  });

  uploader.on('upload-finished', (upload) => {
    dispatch(uploadCompleted(upload));
  });

  uploader.on('upload-progress', ({ id }, progress) => {
    dispatch(uploadProgress({ id, progress }));
  });

  uploader.on('uploader-reset', (uploaderId) => {
    dispatch(resetUploads({ uploaderId }));
  });

  uploader.on('uploader-closed', (uploaderId) => {
    dispatch(resetUploads({ uploaderId }));
  });
}
